import React, { FC } from 'react';
import { Kfh_ArtirixImageType } from '../../types/graphqlTypes';
import Blade from '../Blade';
import { Img } from '../Img';
import { Spacer } from '../Spacer';

interface PropertyEpcBladeProps {
  epcs: Kfh_ArtirixImageType[];
}

export const PropertyEpcBlade: FC<PropertyEpcBladeProps> = ({ epcs }) => (
  <Blade id="propertyEpc" width="wide" heading="EPC" hideFooterOnDesktop>
    <Spacer>
      {epcs?.map((media, i: number) => (
        <Img src={media} key={i} />
      ))}
    </Spacer>
  </Blade>
);

export default PropertyEpcBlade;
